import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { CancelButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import { MODAL_FOOTER_BUTTON_SIZE } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import BuyCoreBrandedButton from '../../../../../Button/core/dsPresets/BuyCoreBrandedButton';
import BoostIllustration from '../BoostIllustration';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
const BoostUpgradeCoreModal = ({ isTier, onRequestClose })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(MessageModal, {
        isOpen: true,
        onRequestClose: onRequestClose,
        image: /*#__PURE__*/ React.createElement(BoostIllustration, null),
        variant: isMobile ? 'vertical' : 'horizontal',
        title: t('boostDeviation.modal.title.upgradeCore'),
        message: /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: `boostDeviation.modal.message.upgradeCore${isTier ? '.tier' : ''}`
        }, "Core+ Memberships and above give you free monthly boosts to make your\\ndeviation more visible in other deviants’ browse feeds.", ' ', /*#__PURE__*/ React.createElement("a", {
            target: "_blank",
            className: "link",
            href: t('boostDeviation.learnMoreUrl'),
            rel: "noreferrer"
        }, "Learn more")),
        footerButtons: [
            /*#__PURE__*/ React.createElement(CancelButton, {
                key: "cancel",
                onClick: onRequestClose
            }, t('popup.cancel')),
            /*#__PURE__*/ React.createElement(BuyCoreBrandedButton, {
                key: "buy-core",
                size: MODAL_FOOTER_BUTTON_SIZE,
                biData: BiData({
                    evid: 375,
                    referral_info: ReferralType.BOOST_UPGRADE_CORE_POPUP
                })
            }, t('common.upgradeNow'))
        ]
    });
};
BoostUpgradeCoreModal.displayName = 'BoostUpgradeCoreModal';
export default BoostUpgradeCoreModal;

//# sourceMappingURL=BoostUpgradeCoreModal.js.map